import { useTranslation } from "react-i18next";
import { TypeAnimation } from 'react-type-animation';

import { useEffect, useState } from 'react';

export default function WhatWeMade(){
    const { t } = useTranslation();

    const [isSmall, setIsSmall] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 640px)');
        const handleChange = () => setIsSmall(!mediaQuery.matches);
        mediaQuery.addEventListener('change', handleChange);
        handleChange();
    }, []);


  return (
    <div class="flex justify-center">    
        <div class="flex flex-col bg-opacity-95 p-6 bg-white rounded-lg shadow-sm mt-8 min-h-64 max-w-7xl w-full">
            <h1 className="text-3xl mb-2 font-bold fade-in-up">
                {t("product_owerwiev")}
            </h1>

            <p class="text-xl px-8 pb-4 whitespace-pre-wrap">
                {t("broduct_brief")}
            </p>

            {/*
            {<TypeAnimation
            sequence={[
                t("sq1"), 500,
                t("sq2"), 500,
                t("sq3"), 500,
                t("sq4"), 500,
                t("sq5"), 500,
                t("sq6"), 1000,
            ]}
            wrapper="h1"
            cursor={false}
            style={{ fontSize: '20px', height: "82px"}}
            />}
            */}

            <div class="flex justify-end">
                <a href="#/products" class={" right flex justify-center w-48 px-3 py-2 font-medium text-center text-white bg-orange-700 rounded-lg hover:bg-orange-800 focus:outline-none"}>
                    {t("our_products")}
                </a>
            </div>

        </div>
        
    </div>
  );

};